import React from 'react';
import { useNavigate } from 'react-router-dom';
import MultiplayerApp from '../MultiplayerApp';

function Multiplayer() {
  const navigate = useNavigate();
  
  const handleBackToMenu = () => {
    navigate('/');
  };
  
  return <MultiplayerApp onBackToMenu={handleBackToMenu} />;
}

export default Multiplayer;